import { Dates } from "../services";
import { EventData } from "../types";

export function generateRandomString(symbols: number) {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < symbols; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

export function isValidEmail(email: string): boolean {
  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  return emailRegex.test(email);
}

export function formatPhoneNumber(phone: string): string {
  let cleanedPhone = phone.replace(/\D/g, "");
  if (cleanedPhone.startsWith("8") && cleanedPhone.length === 11) {
    cleanedPhone = "7" + cleanedPhone.slice(1);
  }
  cleanedPhone = "+" + cleanedPhone;
  return cleanedPhone;
}

export function formatDateOfEvent(date: Date): string {
  const dayOfWeek = new Intl.DateTimeFormat("ru-RU", {
    weekday: "short",
  }).format(date);
  const day = date.getDate();
  const month = new Intl.DateTimeFormat("ru-RU", { month: "long" }).format(
    date
  );
  const time = date.toLocaleTimeString("ru-RU", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return `${dayOfWeek}, ${day} ${month}, ${time}`;
}

export function formatDateTimeStandard(dateInput: string | number) {
  const months = [
    "янв.",
    "фев.",
    "мар.",
    "апр.",
    "мая",
    "июн.",
    "июл.",
    "авг.",
    "сен.",
    "окт.",
    "нояб.",
    "дек.",
  ];

  const date = new Date(dateInput);

  const day = String(date.getDate()).padStart(2, "0");
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day} ${month} ${year} ${hours}:${minutes}`;
}

export function getDeclinedWord(count: number, word: string): string {
  const formsMap: { [key: string]: [string, string, string] } = {
    комментарий: ["комментарий", "комментария", "комментариев"],
  };

  const forms = formsMap[word];
  if (!forms) {
    throw new Error(`Не найдены склонения для слова: ${word}`);
  }

  const mod10 = count % 10;
  const mod100 = count % 100;

  if (mod100 >= 11 && mod100 <= 14) {
    return forms[2];
  }

  if (mod10 === 1) {
    return forms[0];
  }

  if (mod10 >= 2 && mod10 <= 4) {
    return forms[1];
  }

  return forms[2];
}

export function isEventOutdated(date: string): boolean {
  if (!date) return false;
  const eventDate = new Date(date).getTime();
  const now = new Date().getTime();
  return now > eventDate;
}

export function isTabActive(url: string): boolean {
  const path = document.location.pathname;
  if (url === "/") {
    return path === "/";
  }
  const pathTab = path.split("/")[1];
  const urlTab = url.split("/")[1];
  return pathTab?.replace("s", "") === urlTab?.replace("s", "");
}

export function getEventColorClass(data: EventData) {
  switch (true) {
    case data.status_id === 1 &&
      data.date_end &&
      isEventOutdated(data.date_end):
      return "red";
    case data.status_id === 1:
      return "yellow";
    case data.status_id === 2:
      return "gray";
    case data.status_id === 3:
      return "green";
    default:
      return "blue";
  }
}

export function hasCommonElement(arr1: any[], arr2: any[]): boolean {
  return (
    arr1.some((item) => arr2.includes(item)) ||
    arr2.some((item) => arr1.includes(item))
  );
}

export function getMonthAndYear(dateOrTimestamp: Date | number): {
  month: number;
  year: number;
} {
  // Создаем объект Date из переданного значения
  const date = new Date(dateOrTimestamp);

  // Получаем номер месяца (0-11, где 0 — январь, 11 — декабрь)
  const month = date.getMonth() + 1; // Прибавляем 1, чтобы получить номер месяца от 1 до 12

  // Получаем год
  const year = date.getFullYear();

  // Возвращаем объект с номером месяца и годом
  return { month, year };
}

export function getMidMonthDate(dateInfo: Dates): string {
  // Создаем объект Date, используя переданные год и месяц.
  // Устанавливаем день месяца на 15, чтобы получить середину месяца.
  const date = new Date(dateInfo.year, dateInfo.month - 1, 15);

  // Возвращаем дату в формате ISO (YYYY-MM-DD).
  return date.toISOString();
}

export function getDateRange(
  range: "last30days" | "lastYear" | "sinceStartOfYear"
): { date_start: string; date_end: string } {
  const now = new Date();
  let from: Date;
  let to: Date = now;

  switch (range) {
    case "last30days":
      from = new Date();
      from.setDate(now.getDate() - 30);
      break;
    case "lastYear":
      from = new Date();
      from.setFullYear(now.getFullYear() - 1);
      break;
    case "sinceStartOfYear":
      from = new Date(now.getFullYear(), 0, 1);
      break;
    default:
      throw new Error("Unsupported range");
  }

  return {
    date_start: from.toISOString().split("T")[0],
    date_end: to.toISOString().split("T")[0],
  };
}


export function formatRelativeDate(input: number | string): string {
  const inputDate = new Date(input);

  if (isNaN(inputDate.getTime())) {
    return "invalid date";
  }

  const now = new Date();
  const diffMs = inputDate.getTime() - now.getTime();
  const diffMinutes = Math.round(Math.abs(diffMs) / 60000);

  if (Math.abs(diffMs) < 60 * 60 * 1000) {
    if (diffMs < 0) {
      return `${diffMinutes} минут назад`;
    } else {
      return `Через ${diffMinutes} минут`;
    }
  }

  return formatDateOfEvent(inputDate);
}




